import { useEffect } from 'react';
import { initSmoothScroll, destroySmoothScroll } from '../utils/smoothScroll';

export const SmoothScrollWrapper = ({ children }) => {
  useEffect(() => {
    const lenis = initSmoothScroll();

    return () => {
      destroySmoothScroll();
    };
  }, []);

  return <>{children}</>;
};